import { AnalyticsAction, AnalyticsActionSubject, AnalyticsActionSubjectId } from '../../types';
import { BaseInvitePeopleAnalytics } from '../../analytics';

export class ShareableLinkAnalytics extends BaseInvitePeopleAnalytics {
	copyInviteLinkButtonClicked() {
		this.fireUI({
			action: AnalyticsAction.CLICKED,
			actionSubject: AnalyticsActionSubject.BUTTON,
			actionSubjectId: AnalyticsActionSubjectId.COPY_INVITE_LINK_BUTTON,
		});
	}

	enableInviteLinkCloseButtonClicked() {
		this.fireUI({
			action: AnalyticsAction.CLICKED,
			actionSubject: AnalyticsActionSubject.BUTTON,
			actionSubjectId: AnalyticsActionSubjectId.ENABLE_INVITE_LINK_CLOSE,
		});
	}

	enableInviteLinkToggleClicked() {
		this.fireUI({
			action: AnalyticsAction.CLICKED,
			actionSubject: AnalyticsActionSubject.BUTTON,
			actionSubjectId: AnalyticsActionSubjectId.ENABLE_INVITE_LINK_TOGGLE,
		});
	}
}
